import { Injectable, computed, signal } from '@angular/core';

/**
 * Estado global de peticiones HTTP en curso.
 * Permite mostrar un overlay único mientras exista al menos una petición activa.
 */
@Injectable({ providedIn: 'root' })
export class HttpLoadingStateService {
  private readonly activeRequests = signal(0);

  readonly isLoading = computed(() => this.activeRequests() > 0);

  beginRequest(): void {
    this.activeRequests.update((count) => count + 1);
  }

  endRequest(): void {
    this.activeRequests.update((count) => (count > 0 ? count - 1 : 0));
  }
}
